<template>
  <v-app-bar>
    <div class="ml-2 d-flex justify-start align-center app-bar-flex">
      <WFSafeLogo></WFSafeLogo>
    </div>
  </v-app-bar>
</template>

<script setup lang="ts">
import WFSafeLogo from '@/components/WFSafeLogo.vue'
</script>

<style lang="scss" scoped>
.app-bar-flex {
  width: 100%;
}

.logo {
  margin: 1em;
  width: 3%;
}

:deep(.search-input) {
  min-width: 275px !important;
}
</style>
